module.exports = __webpack_public_path__ + "static/media/red_arrow.af83eb46.png";